import  "./aboutUs.scss"
import aboutBottom from "../../assets/images/about_bottom.jpg"
import starIcon from "../../assets/images/star.svg"
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

export default function AboutUs({openModal}) {
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true
    });
  }, []);
  return(
    <>
      <div className="about_wrapper" data-aos="fade-in" id="about">
        <div className="about_counter_bg">
          <div className="container">
            <div className="about_counter">
              <section>
                <h3>100+</h3>
                <span>satisfied guests</span>
              </section>
              <section>
                <h3>10+</h3>
                <span>years of experience</span>
              </section>
              <section>
                <h3>5<img src={starIcon} alt="starIcon"/></h3>
                <span>Google review score</span>
              </section>
              <section>
                <h3>#1</h3>
                <span>luxury charter in <br/>Jamaica</span>
              </section>
            </div>
          </div>
        </div>
        <div className="about_content_wrap">
          <div className="container">
            <div className="about_content" data-aos="fade-up">
              <h1>The Deus Ex Machina</h1>
              <p>The Deus Ex Machina, an AB68 yacht crafted in Tuscany, Italy, is the pinnacle of luxury and performance, produced in limited numbers to ensure exclusivity. This stunning vessel is a testament to elegance on the ocean, offering two beautifully appointed staterooms that exude comfort and sophistication, along with two inviting saloons designed for relaxation or entertaining in style. The yacht features two lavishly finished heads, a fully equipped galley ideal for culinary indulgence, a spacious bow sunpad for basking in the sun, and an aft lounge perfectly suited for leisurely moments or social gatherings. Propelled by twin MAN engines delivering an impressive 3100 horsepower and paired with Rolls Royce jet drives, the Deus Ex Machina offers exceptional power and maneuverability, ensuring a seamless and exhilarating experience on the water. Renowned as Jamaica's finest yacht, this masterpiece guarantees every voyage is nothing short of extraordinary, blending world-class craftsmanship with unparalleled comfort and performance.</p>
            </div>
          </div>
          <img src={aboutBottom} alt="aboutBottom"/>
        </div>
      </div>
      <div className="about_bottom_content">
        <div className="container">
          <p data-aos="fade-up" data-aos-offset="500" data-aos-delay="100">The freshest face in Montego Bay's charter scene. With an astute eye for the unmet desires of our discerning clientele, we're here to redefine luxury on the waves. Unlike the ordinary catamaran charters dotting the coast, we promise an extraordinary experience marked by unparalleled service, culinary excellence, and top-tier beverages.</p>
          <p data-aos="fade-up" data-aos-offset="500" data-aos-delay="200">Our commitment is clear: to set a new standard in charter experiences, ensuring each moment aboard our vessels is nothing short of remarkable. Join us as we embark on a journey to elevate your expectations and create memories that linger long after the waves have settled. We are located at the esteemed Montego BayYacht Club, this extraordinary excursion encompasses a cruise to the renowned Doctors Cave Beach, an immersive snorkeling experience at the Montego Bay Marine Park, and an enlightening tour of the picturesque Lagoons.</p>
          <p data-aos="fade-up" data-aos-offset="500" data-aos-delay="250">If you are seeking a more tailored experience, we invite you to contact us to discuss how we can craft a custom charter designed specifically to meet your needs and preferences.</p>
          <button
            data-aos="fade-up"
            data-aos-offset="500" data-aos-delay="300"
            className="simple_btn white_bg"
            onClick={openModal}
          >
            Contact
          </button>
        </div>
      </div>
    </>
  )
}